import React from "react";
import { useToken, useUser } from "@packsize/authentication";
import { useLocation, useNavigate } from "react-router-dom";

import { useTenantStatus } from "@/hooks/use-tenant-status";
import { useTenants } from "@/hooks/tenant";

import { TenantSelectDropDownTemplate } from "./tenant-select-dropdown.template";

export const TenantSelectDropDown: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { decodedToken } = useToken();
	const { currentUser } = useUser();
	const tenantStatus = useTenantStatus();
	const { data: tenants } = useTenants();

	if (currentUser === null || currentUser === undefined || decodedToken === null || decodedToken === undefined) {
		return null;
	}

	const currentTenant = currentUser.userTenants.find((t) => t.id === decodedToken.tid);
	const isLiveCustomerEnvironment = tenantStatus === "Operating";
	const tenantName = currentTenant?.company ?? "Unknown";
	const handleTenantSelect = (tenantId: string) => {
		const returnTo = `${location.pathname}${location.search}${location.hash}`;
		const searchParams = new URLSearchParams({ tenantId, returnTo });

		navigate(`/site-select?${searchParams.toString()}`);
	};

	return (
		<TenantSelectDropDownTemplate
			tenantName={tenantName}
			isLiveCustomerEnvironment={isLiveCustomerEnvironment}
			tenants={tenants}
			currentTenantId={decodedToken.tid}
			onTenantSelect={handleTenantSelect}
		/>
	);
};
